import React, { Component } from 'react';
import { Card, Form, Input, Row, Col, Button, Tooltip, Divider, Space, Tag, Switch } from 'antd';
import {
  CopyOutlined,
  FullscreenOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  PictureOutlined
} from '@ant-design/icons';
import StyleSlider from './widgets/StyleSlider';

const { TextArea } = Input;

class GeneralInfoTab extends Component {
  render() {
    const { config, onChange, onSave, loading } = this.props;
    
    // Ensure nested objects exist
    const style = config.style || { 
      emoji_level: 50, 
      formality_level: 50, 
      response_length: 50 
    };

    const strategy = config.strategy || {
      name: '',
      tone: '',
      objection_handling_guide: '',
      key_phrases: []
    };

    const handleStyleChange = (field, value) => {
      if (onChange) {
        onChange('style', {
          ...style,
          [field]: value,
        });
      }
    };

    const handleStrategyChange = (field, value) => {
      if (onChange) {
        onChange('strategy', {
          ...strategy,
          [field]: value,
        });
      }
    };

    const addKeyPhrase = (phrase) => {
      if (phrase && !strategy.key_phrases.includes(phrase)) {
        handleStrategyChange('key_phrases', [...strategy.key_phrases, phrase]);
      }
    };

    const removeKeyPhrase = (phrase) => {
      handleStrategyChange('key_phrases', strategy.key_phrases.filter(p => p !== phrase));
    };

    return (
      <div className="general-info-tab">
        <Card
          bordered={false}
          style={{ 
            borderRadius: '12px', 
            boxShadow: '0 2px 12px rgba(0,0,0,0.03)',
            marginBottom: '16px'
          }}
        >
          {/* Section: DANH TÍNH */}
          <div style={{ marginBottom: 40 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24, paddingTop: '10px' }}>
              <span style={{ fontSize: '14px', fontWeight: 800, color: '#1a1a1a', letterSpacing: '0.05em' }}>DANH TÍNH</span>
              <Tooltip title="Thông tin cơ bản định danh Agent">
                <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff', fontSize: '14px' }} />
              </Tooltip>
            </div>

            <Row gutter={32}>
              <Col span={16}>
                <Form layout="vertical">
                  <Form.Item label={<span style={{ fontSize: '11px', fontWeight: 800, color: '#444' }}>TÊN</span>}>
                    <Input
                      placeholder="Phong Linh Master"
                      value={config.agentName}
                      onChange={(e) => onChange('agentName', e.target.value)}
                      style={{ borderRadius: '6px', height: '40px', border: '1px solid #e8ebee' }}
                    />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={8}>
                <Form layout="vertical">
                  <Form.Item label={<span style={{ fontSize: '11px', fontWeight: 800, color: '#444' }}>VAI TRÒ / CHỨC DANH</span>}>
                    <Input
                      placeholder="Sales Agent"
                      value={config.agentRole}
                      onChange={(e) => onChange('agentRole', e.target.value)}
                      style={{ borderRadius: '6px', height: '40px', border: '1px solid #e8ebee' }}
                    />
                  </Form.Item>
                </Form>
              </Col>
            </Row>

            <Row gutter={48} style={{ marginTop: 12 }}>
              <Col span={8}>
                <StyleSlider
                  label="Độ dài phản hồi"
                  leftLabel="Ngắn"
                  rightLabel="Dài"
                  value={style.response_length ?? 50}
                  onChange={(v) => handleStyleChange('response_length', v)}
                  color="#1890ff"
                />
              </Col>
              <Col span={8}>
                <StyleSlider
                  label="Sử dụng Emoji"
                  leftLabel="Tối giản"
                  rightLabel="Thường xuyên"
                  value={style.emoji_level ?? 50}
                  onChange={(v) => handleStyleChange('emoji_level', v)}
                  color="#52c41a"
                />
              </Col>
              <Col span={8}>
                <StyleSlider
                  label="Mức độ trang trọng"
                  leftLabel="Thân mật"
                  rightLabel="Trang trọng"
                  value={style.formality_level ?? 50}
                  onChange={(v) => handleStyleChange('formality_level', v)}
                  color="#fa8c16"
                />
              </Col>
            </Row>

            <Row gutter={32} style={{ marginTop: 8 }}>
              <Col span={16}>
                <Form layout="vertical">
                  <Form.Item label={<span style={{ fontSize: '11px', fontWeight: 800, color: '#444' }}>LỜI CHÀO ĐẦU (GREETING)</span>}>
                    <Input
                      placeholder="VD: Xin chào! Tôi là {{agentName}}, trợ lý của {{company_name}}..."
                      value={config.greetingMessage}
                      onChange={(e) => onChange('greetingMessage', e.target.value)}
                      style={{ borderRadius: '6px', height: '40px', border: '1px solid #e8ebee' }}
                    />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={8}>
                <Form layout="vertical">
                  <Form.Item label={<span style={{ fontSize: '11px', fontWeight: 800, color: '#444' }}>NGÔN NGỮ</span>}>
                    <Input
                      placeholder="Tiếng Việt"
                      value={config.language === 'vi' ? 'Tiếng Việt' : (config.language === 'en' ? 'English' : config.language)}
                      disabled
                      style={{ borderRadius: '6px', height: '40px', border: '1px solid #e8ebee', backgroundColor: '#f9fafb' }}
                    />
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>

          <Divider style={{ margin: '32px 0 32px 0' }} />

          {/* Section: SYSTEM PROMPT */}
          <div style={{ marginBottom: 40 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ fontSize: '14px', fontWeight: 800, color: '#1a1a1a', letterSpacing: '0.05em' }}>HƯỚNG DẪN CỐT LÕI (SYSTEM PROMPT)</span>
                <Tooltip title="Câu lệnh điều khiển toàn bộ hành vi của Agent">
                  <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff', fontSize: '14px' }} />
                </Tooltip>
              </div>
              <Space size={12}>
                <Tooltip title="Sao chép">
                  <Button type="text" icon={<CopyOutlined />} size="small" style={{ color: '#8c8c8c' }} />
                </Tooltip>
                <Tooltip title="Toàn màn hình">
                  <Button type="text" icon={<FullscreenOutlined />} size="small" style={{ color: '#8c8c8c' }} />
                </Tooltip>
              </Space>
            </div>

            <TextArea
              rows={8}
              value={config.systemPrompt}
              onChange={(e) => onChange('systemPrompt', e.target.value)}
              placeholder="Nhập câu lệnh hệ thống chi tiết định nghĩa hành vi của Agent..."
              style={{
                borderRadius: '8px',
                padding: '16px',
                fontSize: '14px',
                lineHeight: '1.6',
                border: '1px solid #e8ebee',
                backgroundColor: '#fff',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
            <span style={{ fontSize: '14px', fontWeight: 800, color: '#1a1a1a', letterSpacing: '0.05em' }}>MÔ TẢ NHÂN CÁCH (PERSONALITY)</span>
          </div>
          <TextArea
            rows={3}
            value={config.agentPersonality}
            onChange={(e) => onChange('agentPersonality', e.target.value)}
            placeholder="Mô tả cá tính, giọng điệu, cách hành xử của Agent..."
            style={{
              borderRadius: '8px',
              padding: '12px 16px',
              fontSize: '14px',
              border: '1px solid #e8ebee',
              marginBottom: 40
            }}
          />

          <Divider style={{ margin: '32px 0 32px 0' }} />

          {/* Section: CHIẾN LƯỢC CHUNG */}
          <div style={{ marginBottom: 40 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
              <span style={{ fontSize: '14px', fontWeight: 800, color: '#1a1a1a', letterSpacing: '0.05em' }}>CHIẾN LƯỢC CHUNG</span>
              <Tooltip title="Chiến lược bán hàng và tiếp cận khách hàng">
                <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff', fontSize: '14px' }} />
              </Tooltip>
            </div>

            <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                    <span style={{ fontSize: '12px', fontWeight: 700, color: '#444' }}>CHÂN DUNG</span>
                    <Tooltip title="Tên và phân loại chiến lược">
                        <InfoCircleOutlined style={{ marginLeft: 6, color: '#bfbfbf', fontSize: '12px' }} />
                    </Tooltip>
                </div>
                <Form layout="vertical">
                    <Form.Item label={<span style={{ fontSize: '10px', color: '#888' }}>TÊN CHIẾN LƯỢC</span>}>
                        <Input
                            placeholder="Tư vấn phong thủy cá nhân hóa"
                            value={strategy.name}
                            onChange={(e) => handleStrategyChange('name', e.target.value)}
                            style={{ borderRadius: '6px', height: '40px' }}
                        />
                        <div style={{ fontSize: '10px', color: '#bfbfbf', fontStyle: 'italic', marginTop: 4 }}>Tên nội bộ để tham chiếu.</div>
                    </Form.Item>
                </Form>
            </div>

            <Row gutter={24}>
              <Col span={12}>
                <Form layout="vertical">
                  <Form.Item label={<span style={{ fontSize: '11px', fontWeight: 800 }}>NHIỆM VỤ CỐT LÕI</span>}>
                    <TextArea
                      rows={4}
                      placeholder="VD: Chiến lược bán hàng 4 giai đoạn..."
                      value={strategy.objection_handling_guide}
                      onChange={(e) => handleStrategyChange('objection_handling_guide', e.target.value)}
                      style={{ borderRadius: '8px' }}
                    />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={12}>
                <Form layout="vertical">
                  <Form.Item label={<span style={{ fontSize: '11px', fontWeight: 800 }}>GIỌNG ĐIỆU GIAO TIẾP</span>}>
                    <TextArea
                      rows={4}
                      placeholder="VD: Thân thiện, tin cậy, thấu hiểu..."
                      value={strategy.tone}
                      onChange={(e) => handleStrategyChange('tone', e.target.value)}
                      style={{ borderRadius: '8px' }}
                    />
                  </Form.Item>
                </Form>
              </Col>
            </Row>

            <div style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    <span style={{ fontSize: '12px', fontWeight: 700, color: '#1a1a1a' }}>TỪ VỰNG</span>
                    <Tooltip title="Các từ khóa, thuật ngữ thương hiệu thường dùng">
                        <InfoCircleOutlined style={{ marginLeft: 6, color: '#1890ff', fontSize: '13px' }} />
                    </Tooltip>
                </div>
                
                <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                    <Input 
                        placeholder="Thêm từ khóa..." 
                        style={{ width: 300, borderRadius: '6px' }}
                        onPressEnter={(e) => {
                            addKeyPhrase(e.target.value);
                            e.target.value = '';
                        }}
                    />
                    <Button 
                        icon={<PlusOutlined />} 
                        style={{ borderRadius: '6px', backgroundColor: '#f0f2f5' }}
                        onClick={() => {
                            const input = document.querySelector('.tag-input-box');
                            if (input && input.value) {
                                addKeyPhrase(input.value);
                                input.value = '';
                            }
                        }}
                    />
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {strategy.key_phrases.map(phrase => (
                        <Tag 
                            key={phrase} 
                            closable 
                            onClose={() => removeKeyPhrase(phrase)}
                            style={{ 
                                borderRadius: '20px', 
                                padding: '4px 12px', 
                                backgroundColor: '#f0f7ff', 
                                border: '1px solid #bae7ff',
                                color: '#1890ff',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 4,
                                margin: 0,
                                fontSize: '12px'
                            }}
                        >
                            {phrase}
                        </Tag>
                    ))}
                </div>
            </div>
          </div>

          {/* Section: CẤU HÌNH NÂNG CAO */}
          <div style={{ marginBottom: 40 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
              <span style={{ fontSize: '14px', fontWeight: 800, color: '#1a1a1a', letterSpacing: '0.05em' }}>CẤU HÌNH NÂNG CAO</span>
              <Tooltip title="Các tính năng bổ trợ tăng cường khả năng của AI">
                <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff', fontSize: '14px' }} />
              </Tooltip>
            </div>

            <Row gutter={32}>
              <Col span={24}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '12px',
                  border: '1px solid #e8ebee'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{ 
                      width: '40px', 
                      height: '40px', 
                      borderRadius: '10px', 
                      backgroundColor: '#e6f7ff', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center' 
                    }}>
                      <PictureOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '14px' }}>Hỗ trợ hình ảnh & OCR</div>
                      <div style={{ color: '#8c8c8c', fontSize: '12px' }}>Cho phép AI "nhìn" và phân tích hình ảnh, trích xuất văn bản từ ảnh khách hàng gửi.</div>
                    </div>
                  </div>
                  <Switch 
                    checked={config.visionEnabled} 
                    onChange={(checked) => onChange('visionEnabled', checked)} 
                  />
                </div>
              </Col>
            </Row>
          </div>

          <Divider style={{ margin: '40px 0 24px 0' }} />

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button 
                type="primary" 
                onClick={onSave} 
                loading={loading}
                style={{ 
                    borderRadius: '8px', 
                    padding: '0 64px',
                    height: '44px',
                    backgroundColor: '#1890ff',
                    fontWeight: 700,
                    fontSize: '15px'
                }}
            >
              Lưu thay đổi
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export default GeneralInfoTab;
